import { m, LazyMotion, domAnimation } from "framer-motion";


const AnimatedLetter = ({ char, index, className, fontSize, tap }) => {
    className = className || "text-primary-400 inline-block select-none";
    fontSize = fontSize || "0.7em";
    tap = tap || { scale: 2.8, rotate: -90, borderRadius: "100%" };
    if (char === " ") {
        return (
            <m.span
                key={index}
                className="select-none"
                style={{ fontSize: fontSize }}
            >
                {char}
            </m.span>
        );
    }
    return (
        <m.span // TODO: Refactor this to a separate component
            key={index}
            className={className}
            style={{ fontSize: fontSize }}
            whileHover={{ scale: 1.2, rotate: 60 }}
            whileTap={tap}
        >
            {char}
        </m.span>
    );
}


export default AnimatedLetter;